(function () {
  customerLogin.$inject = ["API_URL", "CALENDAR_URL", "$http", "$sce", "$rootScope", "$filter", "$timeout", "$location", "SingleSlotService"];
  angular.module('calendarApp').directive('customerLogin', customerLogin);

  function customerLogin(API_URL, CALENDAR_URL, $http, $sce, $rootScope, $filter, $timeout, $location, SingleSlotService) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: smooth.calendar_url + '/partials/directives/customer-login.html',
      scope: true,
      link: function link(scope, elem, attrs) {
        scope.loginScope = scope;
        var searchParams = $location.search();
        scope.customer = {};
        scope.showRego = false; // Show login form first

        scope.regoForm = smooth.forms.registration;
        scope.regoData = {};
        scope.loginForm = {
          orgid: smooth.orgid
        };
        scope.eugdpr = smooth.forms && smooth.forms.eugdpr ? smooth.forms.eugdpr : null;
        scope.orgName = smooth.orgName || '';
        scope.calendarUrl = "".concat(CALENDAR_URL, "/").concat(smooth.orgid);
        scope.rememberme = true;
        scope.mailchimplist = !!smooth.mailchimplist;
        scope.newsletterSubscribe = true; // User should not be able to browse to the login page if they're already logged in.
        // chosen shifts will be stored on rootScope

        scope.hasChosenShift = !!$rootScope.chosenShift;

        if ($location.path() === '/register') {
          scope.showRego = true;
        }

        scope.showEugdpr = function () {
          // EUGDPR
          $('#eugdpr-modal').modal('show');
        };

        scope.submitRego = function () {
          scope.customer.orgid = smooth.orgid;
          scope.customer.facebookid = scope.facebookID;
          scope.customer.reginfo = scope.regoData;
          scope.loading = true;
          $('#eugdpr-modal').modal('hide');
          $('body').removeClass('modal-open');
          $('.modal-backdrop').remove();
          getRecaptchaToken().then(function (token) {
            $http.post(API_URL + '/customerauth/register', {
              token: token,
              customerinfo: scope.customer,
              rememberme: !!scope.rememberme,
              newslettersubscribe: scope.newsletterSubscribe
            }).then(function (reply) {
              scope.loading = false;
              var response = reply.data;

              if (!response.success) {
                scope.errorMessage = $filter('calendarLabel')(response.msg);
                $timeout(function () {
                  scope.errorMessage = '';
                }, 3000);
                console.error('Error: ' + response.msg);
                return;
              }

              scope.successMessage = $filter('calendarLabel')('Registration successful');
              $rootScope.customerInfo = response.customer;
              $timeout(function () {
                scope.successMessage = ''; // This will only be set if the customer is using calendar one.
                // Otherwise serviceid and date params will be set

                if (scope.hasChosenShift) {
                  shift = $rootScope.chosenShift;

                  if (shift.waitlist || shift.timeslots.length > 1 || shift.bookmulti > 1) {
                    $location.path('/chooseslots');
                    return;
                  }

                  SingleSlotService.reserveSlot(shift).then(function () {
                    // No slot chooser, show future days?
                    if (smooth.calendarSettings.bookfuturedays) {
                      $location.path('/futureslots');
                      return;
                    }

                    $location.path('/review');
                  }, function () {// Probably overbooking. The user will have been redirected.
                  });
                } else {
                  var calendarType = localStorage.getItem('calendar-type');

                  if (!calendarType || calendarType !== 'SERVICE_CALENDAR') {
                    $location.path('/');
                  } else {
                    var serviceID = searchParams.serviceid,
                        date = searchParams.date;
                    $location.path('/service-availability/' + serviceID + '/' + date);
                  }
                }
              }, 2000);
            }, function (error) {
              console.error('Error: ' + error.errorMessage);
            });
          });
        };

        scope.submitLogin = function () {
          scope.loading = true;
          scope.emailNotFound = false;
          $http.post(API_URL + '/customerauth/login', {
            customer: scope.loginForm,
            rememberme: scope.rememberme
          }).then(function (reply) {
            scope.loading = false;
            var response = reply.data;

            if (!response.success) {
              if (response.emailnotfound) {
                scope.emailNotFound = response.emailnotfound;
                return;
              }

              scope.errorMessage = $filter('calendarLabel')(response.msg);
              if (!scope.errorMessage) scope.errorMessage = 'Sorry but an expected error has occurred. Please try again and contact support@smoothbook.co ' + 'if this error persists';
              $timeout(function () {
                scope.errorMessage = '';
              }, 3000);
              console.error('Error: ' + response.msg);
              return;
            }

            $rootScope.customerInfo = response.customer;
            scope.successMessage = $filter('calendarLabel')('Login successful');
            $timeout(function () {
              scope.successMessage = '';

              if (scope.hasChosenShift) {
                shift = $rootScope.chosenShift;

                if (shift.waitlist || shift.timeslots.length > 1 || shift.bookmulti > 1) {
                  $location.path('/chooseslots');
                  return;
                } // Skip choose slots


                SingleSlotService.reserveSlot(shift).then(function () {
                  // No slot chooser, show future days?
                  if (smooth.calendarSettings.bookfuturedays) {
                    $location.path('/futureslots');
                    return;
                  }

                  $location.path('/review');
                }, function () {// Probably overbooking. The user will have been redirected.
                });
              } else {
                var calendarType = localStorage.getItem('calendar-type');

                if (!calendarType || calendarType !== 'SERVICE_CALENDAR') {
                  $location.path('/');
                } else {
                  var serviceID = searchParams.serviceid,
                      date = searchParams.date;

                  if (!serviceID || !date) {
                    return $location.path('/');
                  }

                  $location.path('/service-availability/' + serviceID + '/' + date);
                }
              }
            }, 2000);
          }).catch(function (err) {
            console.error(err);
          });
        };

        scope.facebookUpdateRego = function (info) {
          scope.customer.firstname = info.first_name;
          scope.customer.lastname = info.last_name;
          scope.customer.email = info.email;
          scope.facebookID = info.id;
          scope.facebookEmail = info.email;
          $rootScope.safeApply();
        };

        scope.cancel = function () {
          delete $rootScope.chosenShift;
          $location.path('/');
        };
      }
    };
  }

  var getRecaptchaToken = function getRecaptchaToken() {
    return new Promise(function (resolve, reject) {
      grecaptcha.execute('6Ldq-K8UAAAAAJtC6lVsC9Rc-FJXd8UNDphcYtav', {
        action: 'homepage'
      }).then(function (token) {
        resolve(token);
      });
    });
  };
})();